module.exports = __webpack_public_path__ + "img/banner.7d9042c3.png";